import {StatusService} from '../../shared/services/authentication/status.service';
import {EventEnum, PathUrlEnum} from '../../utils/analytics.utils';
import {AnalyticsService} from '../../shared/services/analytics/analytics.service';
import {FormsService} from '../../shared/services/form/forms.service';
import {AuthenticationService} from '../../shared/services/authentication/authentication.service';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ISellerForm, ISellerPayloadData} from 'src/app/shared/interfaces/ISeller';
import {first, delay, map} from 'rxjs';
import {sellerEnum} from 'src/app/shared/enums/seller.enum';
import {typeAuthenticationEnum} from 'src/app/shared/interfaces/IAuthenticationResponse';
import {SessionStorageEnum} from "src/app/shared//enums/sessionStorage.enum";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-forms-list',
  templateUrl: './forms-list.component.html',
  styleUrls: ['./forms-list.component.scss'],
})
export class FormsListComponent implements OnInit {
  seller: ISellerPayloadData = {} as ISellerPayloadData;
  sellerIsPf = false;
  sellerNameOrCompany: string;
  sellerFormPersonalData: ISellerForm;
  sellerFormPropertyDivision: ISellerForm;
  sellerFormsSubmitted = false;
  othersFormsSubmitted = false;
  isLoadingFormsList = true;
  enableFormFilled = false;
  pathUrlOrigin: string;

  loadingSubmit = false;
  showError = false;
  errorCount = 0;

  set isLastSeller(value: boolean) {
    sessionStorage.setItem('isLastSeller', value ? 'true' : 'false');
  }

  get isLastSeller(): boolean {
    return sessionStorage.getItem('isLastSeller') === 'true';
  }

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private formsService: FormsService,
    private statusService: StatusService,
    private analyticsService: AnalyticsService,
  ) {
    this.pathUrlOrigin =
      this.router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString() || '';
  }

 async ngOnInit() {
    this.formsList();
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  goToTracking() {
    this.router.navigateByUrl('tracking');
  }

  logoff() {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_LISTA_FORMS, EventEnum.BTN_VOLTAR);
    if (this.pathUrlOrigin.includes('tracking')) {
      this.goToTracking();
    } else {
      this.authenticationService.logoff();
    }
  }

  isUserSeller() {
    return (
      this.authenticationService.userLogged?.authType === typeAuthenticationEnum.SELLER_PF ||
      this.authenticationService.userLogged?.authType === typeAuthenticationEnum.SELLER_PJ
    );
  }

  goToForm(form: ISellerForm) {
    switch (form?.type) {
      case sellerEnum.FORM_PERSONAL_DATA:
        if (this.seller?.type === sellerEnum.TYPE_PF) {
          this.router.navigateByUrl('seller-info-pf');
        } else if (this.seller?.type === sellerEnum.TYPE_PJ) {
          this.router.navigateByUrl('seller-info-pj');
        }
        break;
      case sellerEnum.FORM_PROPERTY_DIVISION:
        if (this.seller?.type === sellerEnum.TYPE_PF) {
          this.router.navigateByUrl('property-division-pf');
        } else if (this.seller?.type === sellerEnum.TYPE_PJ) {
          this.router.navigateByUrl('property-division-pj');
        }
        break;
    }
  }

  formsList() {
    if (!this.authenticationService.userLogged) {
      return;
    }

    this.formsService
      .getFormsStatusList()
      .pipe(
        delay(1000),
        first(),
        map(response => {
          // Guarda na sessão se é o último vendedor a preencher os formulários
          if (!this.isLastSeller) {
            const isLastSeller = response.otherSellers?.filter(seller => !seller.isFilled).length === 0;
            this.isLastSeller = isLastSeller;
          }
          return response;
        })
      )
      .subscribe({
          next: (response: ISellerPayloadData) => {
            this.analyticsService.track(PathUrlEnum.PROPRIETARIO_LISTA_FORMS);

            this.seller = response;
            this.sellerNameOrCompany = this.seller?.name;
            this.sellerIsPf = this.seller?.type === sellerEnum.TYPE_PF;
            this.sellerFormPersonalData = this.seller?.forms.find(form => form.type === sellerEnum.FORM_PERSONAL_DATA)!;
            this.sellerFormPropertyDivision = this.seller?.forms?.find(form => form.type === sellerEnum.FORM_PROPERTY_DIVISION)!;

            sessionStorage.setItem(SessionStorageEnum.USERNAME, this.sellerNameOrCompany);

            this.sellerFormsSubmitted = this.seller.status === sellerEnum.STATUS_SUBMITTED;

            // Todos os outros vendedores preencheram os formulários e o status está como IN_PROGRESS ou SUBMITTED
            this.othersFormsSubmitted = (this.seller?.otherSellers && Object.keys(this.seller.otherSellers).length > 0)
              ? (this.seller?.otherSellers?.every(form => form.isFilled) && this.seller?.status === sellerEnum.STATUS_SUBMITTED)
              : false;

            // Habilita o botão de finalizar quando os formulários do vendedor principal estiverem preenchidos
            this.enableFormFilled = !!this.seller?.forms?.every(form => form.isFilled);

            // Redireciona para a tela de sucesso se todos os formulários estiverem preenchidos
            if (this.sellerFormsSubmitted && this.othersFormsSubmitted) {
              this.redirectToSellerSuccess();
            }
          },
          error: () => {
            this.statusService.showToast(
              'error',
              'desculpe, não conseguimos carregar a lista de formulários. Por favor, tente novamente',
            );
          },
          complete: () => this.isLoadingFormsList = false
        }
      );
  }

  submitForms(): void {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_LISTA_FORMS, EventEnum.BTN_FINALIZAR_PREENCHIMENTO);
    this.loadingSubmit = true;
    this.formsService.patchFinishSellerUpdate().subscribe({
      next: () => {
        this.loadingSubmit = false;
        this.redirectToSellerSuccess();
      },
      error: () => {
        this.loadingSubmit = false;
        this.showError = true;
      }
    })
  }

  redirectToSellerSuccess() {
    this.router.navigateByUrl('seller-success');
  }

  reciverTryAgain(): void {
    this.errorCount++;
    this.showError = false;
    this.submitForms();
  }

  protected readonly environment = environment;
}
